import { WA_LEARN_MORE_HREFS } from "features/Integration/modules/Whatsapp/constants/Whatsapp.constants";
import React from "react";
import {
  WA_BENEFITS,
  WA_UNLOCKING_KEY_DETAILS,
} from "../../constants/WhatsappIUnlockModal.constants";
import { DetailsSection } from "../../../DetailsSection/DetailsSection";
import { Checklist } from "../../../DetailsSection/modules/Checklist/Checklist";
import { KeyDetails } from "../../../DetailsSection/modules/KeyDetails/KeyDetails";
import { Note } from "../../../DetailsSection/modules/Note/Note";

export const PersonalNumberSection = () => {
  return (
    <DetailsSection
      title={
        <>
          Benefits of connecting your{" "}
          <span className="tw-text-[#493ab1]">WhatsApp Personal Number</span>
        </>
      }
    >
      <Checklist list={WA_BENEFITS} />

      <KeyDetails keyDetails={WA_UNLOCKING_KEY_DETAILS} className="tw-mt-6" />

      <Note
        label={
          <>
            <span className="tw-underline">Note</span>: If you want to use an
            existing number, you must first delete any personal or, WhatsApp
            business accounts associated with the same number.{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href={WA_LEARN_MORE_HREFS.EXISTING_NUMBER}
            >
              Learn more
            </a>
          </>
        }
        className="tw-mt-4 tw-text-[11px] tw-leading-[15px]"
      />
    </DetailsSection>
  );
};
